export function formatLocationAddress(location) {
    const parts = [];
    if (location.address && location.number) {
        parts.push(`${location.address} ${location.number}`);
    }
    else if (location.address) {
        parts.push(location.address);
    }
    if (location.complement?.trim()) {
        parts.push(location.complement.trim());
    }
    if (location.addressLine2?.trim()) {
        parts.push(location.addressLine2.trim());
    }
    if (location.city && location.state) {
        parts.push(`${location.city}, ${location.state}`);
    }
    else if (location.city) {
        parts.push(location.city);
    }
    if (location.zipCode) {
        const formattedZip = formatZipCode(location.zipCode);
        parts.push(`CEP ${formattedZip}`);
    }
    return parts.join('. ');
}
export function formatZipCode(zipCode) {
    const cleanZip = zipCode.replace(/\D/g, '');
    if (cleanZip.length === 8) {
        return `${cleanZip.slice(0, 5)}-${cleanZip.slice(5)}`;
    }
    return zipCode;
}
export function formatContractAddressLine({ street, number, neighborhood, state }) {
    const streetAndNumber = [street, number].filter(Boolean).join(', ');
    const neighborhoodAndState = [neighborhood, state].filter(Boolean).join(', ');
    return [streetAndNumber, neighborhoodAndState].filter(Boolean).join(' - ');
}
export function isValidAddress(location) {
    return Boolean(location.address && location.number && location.city && location.state && location.zipCode);
}
export function getStreetAddress(location) {
    if (location.address && location.number) {
        return `${location.address} ${location.number}`;
    }
    return location.address || '';
}
export function getCityState(location) {
    if (location.city && location.state) {
        return `${location.city}, ${location.state}`;
    }
    return location.city || '';
}
